import { computed, signal } from '@angular/core';
import { defer, finalize, MonoTypeOperatorFunction } from 'rxjs';

export class RequestTracker {
  private readonly pending = signal(0);
  private readonly settled = signal(false);

  readonly loading = computed(() => this.pending() > 0);

  readonly initialLoading = computed(() => this.pending() > 0 && !this.settled());

  track<T>(): MonoTypeOperatorFunction<T> {
    return (source) =>
      defer(() => {
        this.pending.update((count) => count + 1);
        return source.pipe(
          finalize(() => {
            this.pending.update((count) => count - 1);
            if (this.pending() === 0) {
              this.settled.set(true);
            }
          }),
        );
      });
  }

  reset(): void {
    this.settled.set(false);
  }
}
